import type { QuiltFragment } from '@aurora/shared-generated/types/graphql-types';
import React from 'react';

export default React.createContext<QuiltFragment | null>(null);
